module.exports = __webpack_public_path__ + "img/DE01097.f6001aa9.png";